import { createFileRoute } from '@tanstack/react-router'
import { GuidesIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/guides/')({
  loader: () => loadPageData({ data: { kind: 'guides', locale: 'en' } }),
  head: () => staticRouteHead('guides', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <GuidesIndexPage />
    </CatalogProvider>
  )
}
